export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">97影院</h3>
            <p className="text-sm leading-relaxed text-background-50/60">
              97影院提供电视剧全集在线观看，热门国产剧、韩剧、美剧全集免费看，最新剧集更新快，高清蓝光不卡顿，流畅播放。追剧就来97影院。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2">
              {[
                { label: '更新速递', href: '#updates' },
                { label: '热播排行', href: '#ranking' },
                { label: '话题热议', href: '#topics' },
                { label: '观众口碑', href: '#comments' },
                { label: '精选推荐', href: '#cards' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容分类</h3>
            <ul className="space-y-2">
              {['国产剧全集', '韩剧全集', '美剧全集', '最新电视剧', '热门推荐'].map((item) => (
                <li key={item}>
                  <span className="text-sm text-background-50/50">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-50/40 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 97影院 - 电视剧全集在线观看平台
          </p>
          <p className="text-xs text-background-50/40">
            高清蓝光 · 流畅播放 · 永久免费
          </p>
        </div>
      </div>
    </footer>
  );
}